import { Injectable } from '@angular/core';
import { CusHttp } from '../core/services/CusHttp';
//获取站点内容
const SITE_CONTENT = "v1/site-content?id=";
//获取意见返回信息
const FEEDBACKS = "v1/feedbacks";

@Injectable()
export class AboutService {

  constructor(
    private _http: CusHttp
  ) { }

  //获取站点内容
  getSiteContent( id: any ) {
    return this._http.get( `${SITE_CONTENT}${id}` );
  }

  //获取意见返回信息
  getFeedback( formValue: any ) {
    let params = new FormData();
    for ( let i in formValue ) {
      params.append( i, formValue[ i ] );
    }
   return this._http.post(`${FEEDBACKS}`, params);
  }


}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/about/about.service.ts